/**
 * Desc: 云店设置-分区价格
 */

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
import AddPrimarySite from '../addSite';
import AddAreaSelect from './addArea';
import { IPSService } from '@/services/ipsServices';

// 子组件
import { noop } from '@/util';

@Component({
  components: {
    AddAreaSelect,
  },
})
export default class zonePrice extends Vue {
  /* 数据 */

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 网点列表
   * @type {number}
   */
  public areaList: Array<AreaListNew> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 20;

  public keywords = '';
  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  public tableSelect = [];

  @Prop({ default: '0' }) sgId: string;

  /* 方法 */

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchRealSite() {
    this.page = 1;
    this.pageSize = 20;
    this.getAreaList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  onPageSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getAreaList();
  }

  /**
   * 页码变更
   * @param {number} val
   * @return null
   */
  onPageChange(val) {
    this.page = val;
    this.getAreaList();
  }

  /**
   * 获取网点列表
   * @return null
   */
  public getAreaList(): void {
    this.loadingState = true;
    IPSService.areaList({ postParams: { sgId: +this.sgId, page: this.page, pageNum: this.pageSize, keywords: this.keywords } }).then(
      (res) => {
        this.totalCount = res.count;
        this.areaList = (res.list || []).map((v) => {
          v.updatedTimeStr = v.updatedTime ? moment(v.updatedTime * 1000).format('YYYY-MM-DD HH:mm:ss') : '-';
          return v;
        });
        this.loadingState = false;
      },
      () => {
        this.loadingState = false;
      },
    );
  }

  /**
   * 删除区域
   * @param {number} id
   * @return null
   */
  public onDeleteSite(id: number): void {
    this.$confirm('是否删除此区域?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      const postParams = {
        areaId: id,
      };
      IPSService.areaDelete({ postParams }).then((res) => {
        if (res) {
          this.$message.success('删除成功');
          this.getAreaList();
        } else {
          this.$message.error('删除失败');
        }
      });
    });
  }

  handleTableSelect(select) {
    this.tableSelect = select;
  }

  selectSite(code, val) {
    AddPrimarySite.open({
      title: '关联门店',
      sgId: this.sgId,
      code,
      inSiteCodes: val,
    }).then(noop, noop);
  }

  // 没有code是新增，有是配置
  addArea(code?) {
    AddAreaSelect.open({
      sgId: this.sgId,
      areaInfo: code ? code : {},
    }).then((res) => {
      this.getAreaList();
    }, noop);
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getAreaList(); // 获取网点列表
  }

  render(h) {
    return (
      <div>
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keywords} placeholder="区域名称"></el-input>
            <i class="iconfont iconsousuo" onClick={() => this.onSearchRealSite()}></i>
          </div>
        </div>
        <div class="tableWrapper">
          <el-table v-loading={this.loadingState} height={this.$store.state.windowHeight - 282} element-loading-text="加载中" data={this.areaList} ref="multipleTable" on-selection-change={val => this.handleTableSelect(val)} tooltip-effect="light">
            <el-table-column type="selection" width="55px"></el-table-column>
            <el-table-column type="index" label="ID" width="60px" align="center" fixed="left"></el-table-column>
            <el-table-column prop="areaName" label="区域名称" min-width="150px" fixed="left"></el-table-column>
            <el-table-column prop="siteName" label="对应区域店" min-width="150px" show-overflow-tooltip></el-table-column>
            <el-table-column
              prop="mappingSiteCodes"
              label="关联门店"
              min-width="120px"
              align="center"
              {...{
                scopedSlots: {
                  default: (scope) => {
                    if (scope.row.mappingSiteCodes.length > 0) {
                      return (
                        <span
                          class="scopeSpan q-button-link"
                          onClick={() => {
                            this.selectSite(1, scope.row.mappingSiteCodes);
                          }}>
                          {scope.row.mappingSiteCodes.length}
                        </span>
                      );
                    } else {
                      return <span>-</span>;
                    }
                  },
                },
              }}
            />
            <el-table-column prop="empName" label="更新人" min-width="150px" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updatedTimeStr" label="更新时间" align="center" show-overflow-tooltip min-width="100px"></el-table-column>
            <el-table-column
              label="操作"
              min-width="150px"
              align="center"
              fixed="right"
              {...{
                scopedSlots: {
                  default: (scope) => {
                    return (
                      <div>
                        {scope.row.areaId ? (
                          <div>
                            <span class="scopeSpan" onClick={() => this.addArea(scope.row)}>
                              配置
                            </span>
                            <span class="scopeSpan" onClick={() => this.onDeleteSite(scope.row.areaId)}>
                              删除
                            </span>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    );
                  },
                },
              }}
            />
          </el-table>
          <div class="bottomWrapper flex justify-between">
            <div>
              <el-button size="medium" type="primary" onClick={() => this.addArea()}>
                添加区域
              </el-button>
            </div>
            <el-pagination
              on-size-change={this.onPageSizeChange}
              on-current-change={this.onPageChange}
              current-page={this.page}
              page-sizes={[20, 50, 100, 500]}
              page-size={this.pageSize}
              layout="total, sizes, prev, pager, next, jumper"
              total={this.totalCount}></el-pagination>
          </div>
        </div>
      </div>
    );
  }
}
